import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "IotConnect"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 14.25H19.5V11.25H18V18H6V6H12.75V4.5H9.75V1.5H8.25V4.5H6C5.17192 4.50083 4.50083 5.17192 4.5 6V8.25H1.5V9.75H4.5V14.25H1.5V15.75H4.5V18C4.50083 18.8281 5.17192 19.4992 6 19.5H8.25V22.5H9.75V19.5H14.25V22.5H15.75V19.5H18C18.8279 19.4988 19.4988 18.8279 19.5 18V15.75H22.5V14.25ZM19.5 1.5C17.8438 1.50165 16.5017 2.84383 16.5 4.5C16.5028 5.03407 16.6497 5.55748 16.9253 6.015L14.6895 8.25H8.25V15.75H15.75V9.3105L17.985 7.0755C18.4426 7.35079 18.966 7.49745 19.5 7.5C21.1569 7.5 22.5 6.15685 22.5 4.5C22.5 2.84315 21.1569 1.5 19.5 1.5ZM14.25 14.25H9.75V9.75H14.25V14.25ZM18 4.5C18 5.32843 18.6716 6 19.5 6C20.3281 5.99917 20.9992 5.32808 21 4.5C21 3.67157 20.3284 3 19.5 3C18.6716 3 18 3.67157 18 4.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/IotConnect.vue"]]);
